import {Menu, Transition} from "@headlessui/react";
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookShareButton,
    WhatsappIcon,
    WhatsappShareButton
} from "react-share";
import {useContext} from "react";
import {AuthContext} from "contexts/auth/auth.provider";

export default function ShareButton({title, url, className = ''}) {
    const {deviceType} = useContext(AuthContext);
    return (
        <div className={`${className} items-center justify-center`}>
            <div className="relative inline-block text-left">
                <Menu>
                    {({open}) => (
                        <>
                          <span className="rounded-md shadow-sm text-scuttle-orange">
                            <Menu.Button
                                className="inline-flex z-10 justify-center w-full px-2 py-1 text-sm font-bold leading-5  transition duration-150 ease-in-out bg-white border border-scuttle-orange rounded-md hover:text-scuttle-orange focus:outline-none focus:border-scuttle-orange">

                              <svg className="w-5 h-5 "
                                   fill="none"
                                   stroke="currentColor"
                                   viewBox="0 0 24 24"
                                   xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round"
                                                                            strokeWidth={2}
                                                                            d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"/></svg>
                           <span className="ml-1">Share</span>
                </Menu.Button>
              </span>

                            <Transition
                                show={open}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                            >
                                <Menu.Items
                                    static
                                    className={`${!deviceType.mobile ? 'right-0' : ''} absolute z-10 w-56 mt-2 origin-top-right bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg outline-none`}
                                >
                                    <Menu.Item>
                                        {({active}) => (
                                            <div
                                                className={`${
                                                    active
                                                        ? "bg-gray-100 text-gray-900"
                                                        : "text-gray-700"
                                                } w-full px-4 py-2 text-sm leading-5 text-left`}
                                            >
                                                <EmailShareButton
                                                    className="w-full"
                                                    subject={`Rent it from Scuttle - ${title}`} url={url}
                                                    body={"This is the body"}
                                                >
                                                    <div
                                                        className={`flex items-center w-full`}
                                                    >
                                                        <EmailIcon size={32} round={true}/>
                                                        <p className="px-2 text-sm leading-5 text-left text-gray-600">Email</p>
                                                    </div>
                                                </EmailShareButton>
                                            </div>

                                        )}
                                    </Menu.Item>
                                    <Menu.Item>
                                        {({active}) => (
                                            <div
                                                className={`${
                                                    active
                                                        ? "bg-gray-100 text-gray-900"
                                                        : "text-gray-700"
                                                } flex justify-between w-full px-4 py-2 text-sm leading-5 text-left`}
                                            >
                                                <WhatsappShareButton url={url} title={title} onClick={console.log}
                                                                     style={{zIndex: 10}}
                                                >
                                                    <div
                                                        className={`flex items-center w-full`}
                                                    >
                                                        <WhatsappIcon size={32} round={true}/>
                                                        <p className="px-2 text-sm leading-5 text-left  text-gray-600">Whatsapp</p>
                                                    </div>
                                                </WhatsappShareButton>
                                            </div>
                                        )}
                                    </Menu.Item>

                                    <Menu.Item>
                                        {({active}) => (
                                            <a
                                                className={`${
                                                    active
                                                        ? "bg-gray-100 text-gray-900"
                                                        : "text-gray-700"
                                                } flex justify-between w-full px-4 py-2 text-sm leading-5 text-left`}
                                            >
                                                <FacebookShareButton quote={title} url={url}>
                                                    <div
                                                        className={`flex items-center w-full`}
                                                    >
                                                        <FacebookIcon size={32} round={true}/>
                                                        <p className="px-2 text-sm leading-5 text-left text-gray-600">Facebook</p>
                                                    </div>

                                                </FacebookShareButton>
                                            </a>
                                        )}
                                    </Menu.Item>
                                </Menu.Items>
                            </Transition>
                        </>
                    )}
                </Menu>
            </div>
        </div>
    );
}
